import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "fw-bold text-black mb-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_7 = { class: "d-flex align-items-center gap-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_12 = {
  key: 0,
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["colspan"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = { class: "text-muted mt-2" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "fw-bold text-primary" }
const _hoisted_23 = { class: "small text-muted" }
const _hoisted_24 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_25 = { class: "small text-muted" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_33 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h4", _hoisted_3, [
          (_ctx.currentQueueName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "flaticon-folder me-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.currentQueueName), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, " Mes Dossiers à Traiter "))
        ]),
        (_ctx.currentQueueName)
          ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.totalElements) + " dossier(s) dans cette file de validation ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.selectedQueue)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/agent-dashboard",
              class: "btn btn-outline-secondary btn-sm me-2"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "flaticon-arrow-left me-1" }, null, -1),
                _createTextVNode(" Retour au dashboard ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.selectedQueue)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedQueue) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadBescs(1, _ctx.limit))),
              class: "form-select form-select-sm",
              style: {"width":"auto"}
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "Toutes les files", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignedQueues, (queue) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: queue.id,
                  value: queue.id
                }, _toDisplayString(queue.name), 9, _hoisted_8))
              }), 128))
            ], 544)), [
              [_vModelSelect, _ctx.selectedQueue]
            ])
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedStatus) = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadBescs(1, _ctx.limit))),
          class: "form-select form-select-sm",
          style: {"width":"auto"}
        }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("option", { value: "" }, "Tous les statuts", -1),
          _createElementVNode("option", { value: "PENDING" }, "En attente", -1),
          _createElementVNode("option", { value: "VALIDATED" }, "Validés", -1),
          _createElementVNode("option", { value: "REJECTED" }, "Rejetés", -1)
        ]))], 544), [
          [_vModelSelect, _ctx.selectedStatus]
        ]),
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "mot",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher..."
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32),
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadBescs(1, _ctx.limit))),
          class: "btn btn-primary btn-sm"
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
          _createTextVNode(" Actualiser ", -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", _hoisted_11, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _cache[14] || (_cache[14] = _createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }, " Référence BESC ", -1)),
              (!_ctx.selectedQueue)
                ? (_openBlock(), _createElementBlock("th", _hoisted_12, " File "))
                : _createCommentVNode("", true),
              _cache[15] || (_cache[15] = _createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }, " Importateur ", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }, " Port déchargement ", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }, " Statut ", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }, " Niveau risque ", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }, " Créé le ", -1)),
              _cache[20] || (_cache[20] = _createElementVNode("th", { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0" }, " Actions ", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                  _createElementVNode("td", {
                    colspan: _ctx.selectedQueue ? 7 : 8,
                    class: "text-center py-2"
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("span", { class: "text-muted" }, "Chargement...", -1)
                  ]))], 8, _hoisted_14)
                ]))
              : (_ctx.bescs.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _createElementVNode("td", {
                      colspan: _ctx.selectedQueue ? 7 : 8,
                      class: "text-center py-4"
                    }, [
                      _cache[22] || (_cache[22] = _createElementVNode("i", {
                        class: "flaticon-folder-open text-muted",
                        style: {"font-size":"48px"}
                      }, null, -1)),
                      _createElementVNode("p", _hoisted_17, [
                        (_ctx.searchTerm)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Aucun dossier ne correspond à votre recherche \"" + _toDisplayString(_ctx.searchTerm) + "\" ", 1))
                          : (_ctx.selectedStatus)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Aucun dossier avec le statut \"" + _toDisplayString(_ctx.getStatusLabel(_ctx.selectedStatus)) + "\" ", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_20, " Aucun dossier trouvé dans cette file "))
                      ])
                    ], 8, _hoisted_16)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.bescs, (besc) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: besc.id
                    }, [
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(besc.refbesc), 1),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(besc.numeroConnaissement), 1)
                      ]),
                      (!_ctx.selectedQueue)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                            _createElementVNode("div", null, _toDisplayString(besc.queue?.name || 'N/A'), 1),
                            _createElementVNode("div", _hoisted_25, _toDisplayString(besc.queue?.code || ''), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(besc.importateur || '-'), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(besc.portDechargement?.nomPort || '-'), 1),
                      _createElementVNode("td", _hoisted_28, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", _ctx.getStatusBadgeClass(besc.currentStatus?.code)])
                        }, _toDisplayString(besc.currentStatus?.label || 'Inconnu'), 3)
                      ]),
                      _createElementVNode("td", _hoisted_29, [
                        (besc.riskLevel)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["badge", _ctx.getRiskBadgeClass(besc.riskLevel)])
                            }, _toDisplayString(_ctx.getRiskLabel(besc.riskLevel)), 3))
                          : (_openBlock(), _createElementBlock("span", _hoisted_30, "-"))
                      ]),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.format_date(besc.createdAt)), 1),
                      _createElementVNode("td", _hoisted_32, [
                        _createVNode(_component_router_link, {
                          to: { name: 'ViewBesc', params: { id: besc.id }, query: { mode: 'traitement' } },
                          class: "btn btn-success btn-sm",
                          title: "Traiter ce dossier"
                        }, {
                          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                            _createElementVNode("i", { class: "flaticon-check me-1" }, null, -1),
                            _createTextVNode(" Traiter ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}